export { notification };
const notification = () => {
  return [
    {
      label: 'Notifications',
      icon: 'dashboard',
      view: {
        type: 'table',
        content: [
          {
            header: 'No.',
            field: 'no',
          },
          {
            header: 'Title',
            field: 'title',
          },
          {
            header: 'Message',
            field: 'msg',
          },
          {
            header: 'Platforms',
            field: 'meta',
          },
          {
            header: 'Time',
            field: 'create_time',
          },
        ],
      },
      searchOptions: {
        fields: ['title','msg'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      pdf: {
        title: 'Notifications',
        colsWidth: [21, 103, 140, 109, 101],
      },
    },
  ];
};
